// This file is auto-generated by @hey-api/openapi-ts

import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen.js';
import { hotelActionListSharesGsheetsRateChart, hotelActionMakeExcelRateChart, hotelActionMakeGsheetsRateChart, hotelActionShareGsheetsRateChart, hotelActionUnshareGsheetsRateChart, jobDownload, type Options } from '../sdk.gen.js';
import type { HotelActionListSharesGsheetsRateChartData, HotelActionListSharesGsheetsRateChartError, HotelActionListSharesGsheetsRateChartResponse, HotelActionMakeExcelRateChartData, HotelActionMakeExcelRateChartError, HotelActionMakeExcelRateChartResponse, HotelActionMakeGsheetsRateChartData, HotelActionMakeGsheetsRateChartError, HotelActionMakeGsheetsRateChartResponse, HotelActionShareGsheetsRateChartData, HotelActionShareGsheetsRateChartError, HotelActionShareGsheetsRateChartResponse, HotelActionUnshareGsheetsRateChartData, HotelActionUnshareGsheetsRateChartError, HotelActionUnshareGsheetsRateChartResponse, JobDownloadData, JobDownloadError, JobDownloadResponse } from '../types.gen.js';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const hotelActionListSharesGsheetsRateChartQueryKey = (options: Options<HotelActionListSharesGsheetsRateChartData>) => createQueryKey('hotelActionListSharesGsheetsRateChart', options);

/**
 * List the shares of a gsheets chart.
 */
export const hotelActionListSharesGsheetsRateChartOptions = (options: Options<HotelActionListSharesGsheetsRateChartData>) => queryOptions<HotelActionListSharesGsheetsRateChartResponse, HotelActionListSharesGsheetsRateChartError, HotelActionListSharesGsheetsRateChartResponse, ReturnType<typeof hotelActionListSharesGsheetsRateChartQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hotelActionListSharesGsheetsRateChart({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hotelActionListSharesGsheetsRateChartQueryKey(options)
});

/**
 * Generate and download the latest excel chart.
 */
export const hotelActionMakeExcelRateChartMutation = (options?: Partial<Options<HotelActionMakeExcelRateChartData>>): UseMutationOptions<HotelActionMakeExcelRateChartResponse, HotelActionMakeExcelRateChartError, Options<HotelActionMakeExcelRateChartData>> => {
    const mutationOptions: UseMutationOptions<HotelActionMakeExcelRateChartResponse, HotelActionMakeExcelRateChartError, Options<HotelActionMakeExcelRateChartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelActionMakeExcelRateChart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate a gsheets chart and return a URI for it.
 */
export const hotelActionMakeGsheetsRateChartMutation = (options?: Partial<Options<HotelActionMakeGsheetsRateChartData>>): UseMutationOptions<HotelActionMakeGsheetsRateChartResponse, HotelActionMakeGsheetsRateChartError, Options<HotelActionMakeGsheetsRateChartData>> => {
    const mutationOptions: UseMutationOptions<HotelActionMakeGsheetsRateChartResponse, HotelActionMakeGsheetsRateChartError, Options<HotelActionMakeGsheetsRateChartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelActionMakeGsheetsRateChart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Share a gsheets chart with an email address.
 */
export const hotelActionShareGsheetsRateChartMutation = (options?: Partial<Options<HotelActionShareGsheetsRateChartData>>): UseMutationOptions<HotelActionShareGsheetsRateChartResponse, HotelActionShareGsheetsRateChartError, Options<HotelActionShareGsheetsRateChartData>> => {
    const mutationOptions: UseMutationOptions<HotelActionShareGsheetsRateChartResponse, HotelActionShareGsheetsRateChartError, Options<HotelActionShareGsheetsRateChartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelActionShareGsheetsRateChart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Un-share a gsheets chart with an email address.
 */
export const hotelActionUnshareGsheetsRateChartMutation = (options?: Partial<Options<HotelActionUnshareGsheetsRateChartData>>): UseMutationOptions<HotelActionUnshareGsheetsRateChartResponse, HotelActionUnshareGsheetsRateChartError, Options<HotelActionUnshareGsheetsRateChartData>> => {
    const mutationOptions: UseMutationOptions<HotelActionUnshareGsheetsRateChartResponse, HotelActionUnshareGsheetsRateChartError, Options<HotelActionUnshareGsheetsRateChartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await hotelActionUnshareGsheetsRateChart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Run a built-in query and download the results as tsv
 */
export const jobDownloadMutation = (options?: Partial<Options<JobDownloadData>>): UseMutationOptions<JobDownloadResponse, JobDownloadError, Options<JobDownloadData>> => {
    const mutationOptions: UseMutationOptions<JobDownloadResponse, JobDownloadError, Options<JobDownloadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await jobDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
